import generateIcon from './generateIcon.js';
import Loading from './svgs/Loading.svg.js';

var LoadingOutlined = generateIcon(Loading, {
  name: 'LoadingOutlined'
});

export { LoadingOutlined as default };
//# sourceMappingURL=LoadingOutlined.js.map
